import styled, { keyframes } from 'styled-components';
import { Button, Tag, Select } from 'antd';
import { EllipsisTooltip } from '@components/common';

export const ComparePanelWrapper =  styled.div`
  display: flex;
  flex-direction: column;
`;

export const Wrapper = styled.div`
  padding: 3px;
  margin: 5px;
  color: #333;
  display: flex;
  background-color: #ECECEC;
  margin-bottom: 0px;
  position: relative;
  padding-left: 10px;
  .anticon.anticon-close {
    vertical-align: 0.125em;
  }
`;

const loaderFrames = keyframes`
  from { height: 0% }
  to { height: 90% }
`;

export const VerticalBar = styled.span`
  position: absolute;
  width: 0.3rem;
  left: 0;
  bottom: 0;
  background: ${(props) => props.color};
  z-index: 1;
  height: 100%;
`;

export const VerticalLoadingBar = styled.span`
  position: absolute;
  width: 0.3rem;
  left: 0;
  bottom: 0;
  background: ${(props) => props.color};
  z-index: 1;
  animation-name: ${loaderFrames};
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
  animation-duration: 6s;
  animation-timing-function: ease-out;
  animation-play-state: running;
`;


export const StyledTag = styled(Tag)`
  position: relative;
  font-size: 14px;
  padding: 5px 8px;
  padding-right: 20px;
  background-color: white;
  align-self: center;
  cursor: pointer;
  background: ${(props) => props.highlight};
  .anticon-close  {
    height: 100%;
    display: flex;
    position: absolute;
    right: 0px;
    top: 0%;
    border-left: 1px solid ${(props) => props.highlight};
    padding: 0px 2px;
    filter: opacity(0.75);
    &:hover {
      background: ${(props) => props.highlight};
      filter: opacity(1);
    }
  }
`;

export const ClearButton = styled.div`
  width: 20px;
  height: 100%;
  line-height: 1;
  justify-content: center;
  display: flex;
  align-items: baseline;
  font-size: 1em;
  color: #333;
  div {
    cursor: pointer;
  }
`;

export const StyledEllipsisTooltip = styled(EllipsisTooltip)`
  max-width: 250px;
  width: auto;
  line-height: 0.9;
  overflow: visible;
  overflow-x: clip;
`;

export const StyledPrimaryEllipsisTooltip = styled(EllipsisTooltip)`
  max-width: 500px;
  width: auto;
  line-height: 1;
  font-size: 24px;
  overflow: visible;
  overflow-x: clip;
`;

export const PrimaryFilterWrapper = styled.div`
  padding-right: 0px;
`;

export const EditFilterButton = styled(Button)`
  font-size: 16px;
  margin-left: 5px;
  border-left: 1px solid #aaa;
  border-radius: 0px;
`;


export const StyledSelect = styled(Select)`
  width: 155px;
  transition: width ease-in-out 0.25s;
  &.ant-select-open {
    width: 500px;
  }
`;
